module.exports = __webpack_public_path__ + "static/media/ic-time.8204826c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-time.svg
// module id = 676
// module chunks = 14